import Abstract from "../../../../abstract-view/abstract.js";

export default class EmptyItem extends Abstract {
  constructor() {
    super();
  }
}
